import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";
import {UserProfile} from "./UserProfile";


@Injectable({
   providedIn: 'root'
})
export class MovimentoFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService) {
   }
}

export enum STATO_ORDINE{
   BOZZA = "bozza",
   COMPLETO = "completo",
}

export enum TIPO_ORDINE{
   CLIENTE = "cli",
   CLIENTE_RESO = "cli_r",
   FORNITORE = "for",
   FORNITORE_RESO = "for_r",
   TRASFERIMENTO = "tras",
   AMMANCO = "amm"
}

export class MovimentoData {
   id?: number;
   pvendita?: number;
   ordine_id?: number;
   ordine_slave?: number;
   vendor?: number | any;
   pvendita_prod_var_instance?: number;
   convalida_slave?:number;
   reso?:boolean;
   qta?:number;
   tipo?:string;
}

export class Movimento {

   data:MovimentoData = {}

   constructor(data:MovimentoData) {
      // assegno al mio oggetto data (è un json)
      if(!data) data = {}
      Object.assign(this.data, data)
   }

   public static TipoMovimento = [
      {value:'cli', display:"Ordine Cliente"},
      {value:'wb', display:"Ordine Web"},
      {value:'cli_r', display:"Reso Cliente"},
      {value:'for', display:"Ordine Fornitore (Convalida DDT)"},
      {value:'for_r', display:"Reso Fornitore"},
      {value:'tras', display:"Trasferimento Merce"},
      {value:'amm', display:"Ammanco"},
      {value:'esu', display:"Esubero"},
   ]

}
